import { QueryHookOptions, useQuery } from "@apollo/client";
import meProBuyerProjectsGql from "@whoppah/apollo/query/pro-projects/meProBuyerProjects.graphql";
import { MeProBuyerProjectsQuery } from "@whoppah/apollo/schema";

/**
 * FULL, READ_ONLY or NONE. Network-first: a CS change shows on the next page
 * view. Its own module (re-exported by `useProBuyerProjects`) because the
 * WHO-6629 workspace provider in `_app` asks it on every page: importing it
 * from there would put every Pro Buyer project operation in the global bundle.
 */
export const useProBuyerProjectsAccess = (
  options?: QueryHookOptions<MeProBuyerProjectsQuery>
) =>
  useQuery<MeProBuyerProjectsQuery>(meProBuyerProjectsGql, {
    fetchPolicy: "cache-and-network",
    ...options,
  });
